<script lang="ts" setup>
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";

interface Props {
  title: string;
  description?: string;
}

defineProps<Props>();
const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const isMobileView = breakpoints.smallerOrEqual("xl");

</script>

<template>
  <section
    class="org-settings-content"
    :class="{ 'org-settings-content--mobile': isMobileView }"
  >
    <div class="org-settings-content__header">
      <p class="org-settings-content__title">
        {{ title }}
      </p>
    </div>

    <div class="org-settings-content__body">
      <p
        v-if="description"
        class="org-settings-content__description"
      >
        {{ description }}
      </p>

      <slot />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.org-settings-content {
  display: flex;

  &__header {
    flex: 1;
  }

  &__body {
    display: flex;
    flex-flow: column;
    gap: spacing.$xxs;
    flex: 5;
  }

  &__title {
    font-size: typography.$base-font-size;
    line-height: typography.$base-line-height;
    font-weight: typography.$font-weight-bold;
  }

  &__description {
    font-size: typography.$base-font-size;
    line-height: typography.$base-line-height;
    font-weight: typography.$font-weight-medium;
  }

  &__title,
  &__description {
    margin: 0;
  }

  &--mobile {
    flex-flow: column;
    gap: spacing.$xxs;
  }
}
</style>
